var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgSireCourseStrikeRate(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M13.54 9.78V5H20v1.43h-5.02v8.14H20V16h-6.46v-4.8H7.88V9.78zm-7.3 4.62c-.3.14-1.04.33-2 .33C1.3 14.74 0 12.9 0 10.8 0 8 2.04 6.6 4.4 6.6c.9 0 1.65.18 1.98.35L5.95 8.6a3.85 3.85 0 00-1.46-.28c-1.22 0-2.27.7-2.27 2.33 0 1.44.85 2.33 2.3 2.33.5 0 1.1-.1 1.42-.23l.3 1.66z",
    fill: "#010101"
  })));
}
export default SvgSireCourseStrikeRate;